export default "__VITE_ASSET__DgfuQAQb__"